/* eslint-disable react/react-in-jsx-scope */
/* ================= Application Details ================= */
export const documentCaseColumns = [
  {
    header: (
      <div className="caseid-header">
        <span>Case ID</span>
      </div>
    ),
    accessor: "caseId",
    render: (value, row, _, onRowSelect, showCheckbox = true) => (
      !showCheckbox ? (
        <span>{value}</span>
      ) : (
      <div className="caseid-with-checkbox">
        <input
          type="checkbox"
          checked={onRowSelect?.selected?.some((r) => r.caseId === row.caseId)}
          onChange={() => onRowSelect?.(row)}
        />
        <span>{value}</span>
      </div>
      )
    ),

  },
  { accessor: "submitDate", header: "Submit Date" },
  { accessor: "origin", header: "Origin" },
  { accessor: "firstName", header: "First Name" },
  { accessor: "lastName", header: "Last Name" },
  { accessor: "caseManager", header: "Case Manager" },
  { accessor: "updatedAt", header: "Updated At" },
  { accessor: "notes", header: "Notes" },
];

export const documentCaseStaticRow = {
  caseId: "-",
  submitDate: "-",
  origin: "-",
  firstName: "-",
  lastName: "-",
  caseManager: "-",
  updatedAt: "-",
  notes: "-",
};

/* ================= Document Quality ================= */
export const documentQualityColumns = (setOpenDoc) => [
  {
    header: "Case ID",
    accessor: "caseId",
    render: (_, row, __, onRowSelect, showCheckbox = true) => (
      !showCheckbox ? (
        <span>{row.caseId}</span>
      ) : (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <input
          type="checkbox"
          checked={onRowSelect?.isSelected
            ? onRowSelect.isSelected(row)
            : onRowSelect?.selected?.some((r) => r.documentId === row.documentId)}
          onChange={() => onRowSelect?.(row)}
        />
        <span>{row.caseId}</span>
        {' '}
      </div>
      )
    ),
  },
  { header: "Document Type", accessor: "documentType", width: "11%" },
  { header: "Document ID", accessor: "documentId", width: "19%" },
  { header: "Submit Date", accessor: "submitDate", width: "8%" },
  { header: "File Size", accessor: "fileSize", width: "7%" },
  {
    header: "Document Name",
    accessor: "documentName",
    width: "19%",
    render: (value, row) => ((row.fileUrl && row.fileUrl !== "-") ? (
      <span
        onClick={() => setOpenDoc({
          fileUrl: row.fileUrl,
          documentName: row.documentName,
        })}
        style={{
          color: "#007bff",
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        {value}
      </span>
    ) : (
      value
    )),
  },
  { header: "Description", accessor: "description", width: "17%" },
  { header: "Notes", accessor: "notes", width: "10%" },
];
